<template>
  <custom-callout class="callout" :has-border="false" :has-toggle="false">
    <validation-observer ref="evalutatorFromRef">
      <div class="row mt-2 row-container py-2">
        <div class="col-md-3 col-12 border-right status">
          <div class="row">
            <div v-if="!evaluator.isSpecialized" class="col-12 col-md-3">
              <custom-percentage
                class="custom-percent"
                :percentage="Number(evaluator.evaluationResult).toString()"
              />
            </div>
            <div class="col-12 col-md-9 d-none d-md-block">
              <div class="label">Nombre:</div>
              <span class="info">
                {{ evaluator.fullName | capitalize }}
                <span v-if="evaluator.isSpecialized" class="bold">
                  / Especializado
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-9">
          <div class="row">
            <div class="col-12 d-block d-md-none">
              <div class="label">Nombre:</div>
              <span class="info">
                {{ evaluator.fullName | capitalize }}
              </span>
            </div>
            <div class="col-12 col-md-2">
              <div class="label">Usuario:</div>
              <span class="info">
                {{ evaluator.userName }}
              </span>
            </div>
            <div class="col-12 col-md-2">
              <div class="label">Rol:</div>
              <span class="info">
                {{ evaluator.roleName }}
              </span>
            </div>
            <div class="col-12 col-md-3">
              <div class="label">Estatus:</div>
              <span class="info">
                {{ evaluator.proposalEvaluationName }}
              </span>
            </div>
            <div class="col-12 col-md-3">
              <div class="label">Fecha:</div>
              <span class="info">
                {{ evaluator.submittedDate | date }}
              </span>
            </div>
            <div
              class="col-12 col-md-2 d-flex justify-content-center align-items-start"
            >
              <dropdown
                v-if="!canDelete"
                class="actions-dropdown"
                :data-item="{ evaluator, index }"
                :items="actionItems"
                title="Acciones"
              />
              <action-button
                v-if="canDelete"
                class="py-1"
                i="fa fa-times-circle"
                variant="outline-danger"
                @click="onRemoveHandler(evaluator)"
              >
                Remover
              </action-button>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </custom-callout>
</template>
<script>
import CustomPercentage from 'custom-percentage';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import Dropdown from 'dropdown';
import _generalApi from '@/modules/app/api';
import alertMixin from 'utils/mixins/alert.mixin';
import {
  removeEvaluatorUserProposal as _removeEvaluatorUserProposal,
  cancelProposalEvaluation,
  evaluationFormPDF as _evaluationFormPDF,
} from '@/modules/serviceProposalHistory/api.js';
import proposalEvaluationStatus from '@/utils/constants/proposalEvaluationStatus.js';
import { proposalRequestStatus } from '@/utils/constants/proposalRequestStatus';

export default {
  components: {
    CustomPercentage,
    CustomCallout,
    ActionButton,
    Dropdown,
  },
  mixins: [alertMixin],
  props: {
    evaluator: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: () => {},
    },
    rubricId: {
      type: Number,
      default: () => {},
    },
  },
  data: () => ({
    canDelete: true,
  }),
  computed: {
    canViewActions() {
      return (
        this.evaluator.proposalEvaluationStatusId ===
          proposalEvaluationStatus.Evaluada ||
        this.evaluator.proposalEvaluationStatusId ===
          proposalEvaluationStatus.Anulada
      );
    },
    actionItems() {
      if (!this.canViewActions) {
        return [];
      }

      const evaluator = { ...this.evaluator };
      return [
        {
          name: 'details',
          label: 'Ver detalle',
          icon: 'fas fa-search-plus text-green pr-1',
          visible: this.canViewActions,
          click: () => {
            this.$router.push({
              name: 'ServiceProposalEvaluationUser',
              params: {
                proposalRequestId: evaluator.proposalRequestId,
                userId: evaluator.userId,
                readOnly: true,
              },
            });
          },
        },
        {
          name: 'print',
          label: 'Descargar Evaluacion',
          icon: 'fas fa-print text-green pr-1',
          visible: this.canViewActions,
          click: this.printDocumentPDF,
        },
        {
          name: 'cancel',
          label: 'Anular Evaluación',
          icon: 'fas fa-ban text-red pr-1',
          visible:
            this.userHasPermissions('proposal.evaluator.cancelEvaluation') &&
            [proposalEvaluationStatus.Evaluada].includes(
              evaluator.proposalEvaluationStatusId
            ) &&
            [
              proposalRequestStatus.Evaluated,
              proposalRequestStatus.EvaluationProcess,
            ].includes(evaluator.proposalRequestStatusId),
          click: this.cancelEvaluation,
        },
        // (Tenerlo presente para la actualizacion del DropDown con el actionButton (cuando solo es 1 elemento){
        //   name: 'remove',
        //   label: 'Remover',
        //   class:"outline-danger py-1 text-danger",
        //   icon:"fa fa-times-circle",
        //   visible: this.evaluator.proposalEvaluationStatusId === proposalEvaluationStatus.Pendiente,
        //   click: ()=> { this.onRemoveHandler(evaluator) }
        // }
      ];
    },
  },
  mounted() {
    this.initCanDelete();
  },
  methods: {
    async onRemoveHandler(evaluator) {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea remover la asignación del evaluador?',
        'Si',
        'No'
      );
      if (!answer) {
        return;
      }

      let parameters = {
        ProposalRequestId: evaluator.proposalRequestId,
        UserId: evaluator.userId,
      };

      await _removeEvaluatorUserProposal(parameters)
        .then(() => {
          this.$emit('on-remove');

          this.ShowToast(
            'Alerta',
            'El evaluador ha sido removido de la propuesta de servicio.',
            'success'
          );
        })
        .catch((err) => {
          if (err.response != null)
            this.Toast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    initCanDelete() {
      // Estatus pendiente
      this.canDelete =
        this.evaluator.proposalEvaluationStatusId ===
        proposalEvaluationStatus.Pendiente;
    },
    async cancelEvaluation({ evaluator }) {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea anular el resultado de la evaluación?',
        'Si',
        'No'
      );
      if (!answer) {
        return;
      }

      await cancelProposalEvaluation(evaluator.evaluatorUserProposalId)
        .then(() => {
          this.ShowToast(
            'Alerta',
            `La evaluación de ${evaluator.fullName} ha sido anulada exitosamente.`,
            'success',
            5000
          );
          this.$emit('on-remove');
        })
        .catch((err) => {
          this.Toast(
            'Alerta',
            err.response.data.message || 'error',
            'error',
            5000
          );
        });
    },
    async printDocumentPDF(value) {
      let parameters = {
        proposalRequestId: value.evaluator.proposalRequestId,
        proposalEvaluationTypeId: value.evaluator.proposalEvaluationTypeId,
        userId: value.evaluator.userId,
        proposalEvaluationFormId: value.evaluator.proposalEvaluationFormId,
        rubricId: this.rubricId,
      };

      await _evaluationFormPDF(parameters).then((response) => {
        _generalApi.ConvertToBlob(response.data);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.label {
  font-weight: normal;
  font-size: 0.875rem;
  color: map-get($colors, 'secondary-6');
}

.info {
  font-weight: normal;
  color: map-get($colors, 'black');
}
</style>
